// src/store/slices/searchSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiUrl } from "../constants/apiUrl";

export const fetchSearchs = createAsyncThunk(
  "search/fetchSearchs",
  async (text, thunkAPI) => {
    try {
      // const params = new URLSearchParams();
      const state = thunkAPI.getState(); // Access Redux state


      console.log(state.auth.userArray.access_token, "state.auth.userArray.access_token");

      const response = await axios.get(
        `${apiUrl}/search?query=${text}`,
        {
          headers: {
            Authorization: `Bearer ${state.auth.userArray.access_token}`,
          },
        }
      );

      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.errors
          ? Object.values(error.response.data.errors)[0][0]
          : "حدث خطأ أثناء جلب العقارات"
      );
    }
  }
);


const searchSlice = createSlice({
  name: "search",
  initialState: {
    list: [],
status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSearchs.pending, (state) => {
       state.status = "loading";
        state.error = null;
      })
      .addCase(fetchSearchs.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.list = action.payload;
      })
      .addCase(fetchSearchs.rejected, (state, action) => {
       state.status = "failed";
        state.error = action.payload;
      })


  },
});

export default searchSlice.reducer;
